
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".7","x":".5","y":".5","width":"29","height":"29","rx":"4.5","stroke":"#C7C7C7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.01 4.6h.5l7 .003h.502l-.002.502-.004.92h4.558V25.4H6.439V6.025h4.57V4.6zM19 7.22l.001-.195h3.563V24.4H7.439V7.025h3.57v1.051H8.81v14.717h12.386V8.076h-2.2L19 7.22zm-.008 1.856l-.004 1.026-.002.498H11.01V9.076h-1.2v12.717h10.386V9.076h-1.204zM12.01 5.6v4h5.98L18 7.216l.008-1.613L12.01 5.6zM10.99 15.62h8.024v1H10.99v-1zm8.024-2.662H10.99v1h8.024v-1z","fill":"#9B9B9B"}})])
          )
        }
      }
    